export const languages = ['en', 'fr'] as const;
export const availableLanguages: {
  label: string;
  value: string;
}[] = [
  { label: 'English (En)', value: 'en' },
  { label: 'French (Fr)', value: 'fr' },
];
export type Language = typeof languages[number];
